import ConversationActionTypes from '../types/conversation';

const ActiveConversationReducer = function(/*state, action*/) {
  var defaultState = { loading: false, messages: [], error: {} };
  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case ConversationActionTypes.SELECT_CONVERSATION:
      return Object.assign(defaultState, action.conversation);
    case ConversationActionTypes.DESELECT_CONVERSATION:
      return defaultState;
    case ConversationActionTypes.REQUESTING:
      var store = Object.assign(defaultState, action.conversation);
      store.loading = true;
      return store;
    case ConversationActionTypes.ERROR:
      return Object.assign(defaultState, { error: action.error });
  }

  return Object.assign(defaultState, state);
};

export default ActiveConversationReducer;
